import React from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'

import styles from './Button.module.scss'
import forwardIcon from '../../assets/icons/icn_forward.png'

interface IProps {
  buttonDescription: string
  buttonColor?: boolean
  onClick: () => void
  classWidth?: boolean
  center?: boolean
  disabled?: boolean
}

export const Button = ({ buttonDescription, buttonColor, classWidth, center, onClick, disabled }: IProps) => {
  return (
    buttonColor ?
      <div className={center ? styles.Center : ''}>
        <button
          onClick={onClick}
          className={`${classWidth ? styles.BlackButton : styles.BlackButtonWide} ${disabled && styles.Disabled}`}
          disabled={disabled}>
          <FormattedMessage id={buttonDescription}/>
        </button>
      </div>
      :
      <button
        onClick={onClick}
        className={`${styles.GreenButton} ${classWidth && styles.Wide} ${disabled && styles.Disabled}`}
        disabled={disabled}>
        <span className={styles.ButtonContent}>
          <FormattedMessage id={buttonDescription}/>
          <img className={styles.IconForward} src={forwardIcon} alt={'forward'}/>
        </span>
      </button>
  )
}
